/*
 *  DIGITALX LABS(PVT)LTD PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  Copyright © 2019. DIGITALX LABS(PVT)LTD
 *  All Rights Reserved.
 *
 *  NOTICE:  All information contained herein is, and remains
 *  the property of DIGITALX LABS(PVT)LTD.  The intellectual and technical concepts contained
 *  herein are proprietary to DIGITALX LABS(PVT)LTD.
 *  Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  is strictly forbidden unless prior written permission is obtained from DIGITALX LABS(PVT)LTD.
 */
import React, { createContext, useState, useMemo } from 'react'
import PropTypes from 'prop-types'

export const MessageHandlerContext = createContext(null)

const MessageHandlerContextProvider = (props) => {
  const [globalLoader, setGlobalLoader] = useState(false)
  const [globalMessage, setGlobalMessage] = useState(null)
  const [purchasedState, setPurchasedState] = useState(null)
  const [otpTimerState, setOtpTimerState] = useState(60)
  const [themeState, setThemeState] = useState('')
  const valueProvider = useMemo(() => ({
    globalLoader,
    setGlobalLoader,
    globalMessage,
    setGlobalMessage,
    purchasedState,
    setPurchasedState,
    otpTimerState,
    setOtpTimerState,
    themeState,
    setThemeState
  }), [globalLoader, globalMessage, purchasedState, otpTimerState, themeState])

  return (
    <MessageHandlerContext.Provider value={valueProvider}>
      {props.children}
    </MessageHandlerContext.Provider>
  )
}

MessageHandlerContextProvider.propTypes = {
  children: PropTypes.element
}

export default MessageHandlerContextProvider
